/* Hover Boxes Block JS File */
$(document).ready(function() {
	if ($('.hover-boxes-wrapper .section-content-wrapper .section-content').length > 0) {
		matchHeight('.hover-boxes-wrapper .section-content-wrapper .section-content');
	}
});
